var focusStyles = {
  boxShadow: '0 0 0 4px #D9E0FF',
  borderColor: '#6881FF',
  borderStyle: 'solid',
  borderWidth: '1px'
};
var focusWithOffsetStyles = {
  '[tabindex="-1"]': {
    position: 'relative',
    ':before': {
      borderRadius: '4px',
      bottom: '-3px',
      boxShadow: '0 0 0 4px #D9E0FF',
      left: '-5px',
      right: '-5px',
      top: '-3px',
      borderColor: '#6881FF',
      borderStyle: 'solid',
      borderWidth: '1px',
      content: "''",
      position: 'absolute'
    }
  }
};
export { focusStyles, focusWithOffsetStyles };